import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How long is the RAMESCO code valid?',
      answer: 'The RAMESCO promo code has lifetime validity! Once you use it, the 55% discount applies to your purchase permanently. There are no expiration dates or time limits on this exclusive offer.'
    },
    {
      question: 'Can I use the code on multiple accounts?',
      answer: 'The RAMESCO code can be used once per customer account. However, the discount applies to any challenge size you choose, from $10K all the way up to $200K funding options.'
    },
    {
      question: 'What\'s included in the 55% discount?',
      answer: 'The 55% discount applies to all QT Funded challenge types and sizes. This includes instant activation, full platform access, all trading tools, educational resources, and priority customer support. No features are excluded.'
    },
    {
      question: 'How quickly can I start trading?',
      answer: 'Once you complete your purchase with the RAMESCO code, your account is activated instantly. You can start trading immediately and begin working towards your funded account goals right away.'
    },
    {
      question: 'What are the profit split terms?',
      answer: 'QT Funded offers industry-leading profit splits of up to 90%. You keep the majority of your trading profits, and payouts are processed quickly through multiple convenient methods.'
    },
    {
      question: 'Is there a refund policy?',
      answer: 'Yes, QT Funded offers a 14-day refund policy if you\'re not satisfied with your challenge. However, with the RAMESCO 55% discount, you\'re getting exceptional value from day one.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-5xl font-black text-gray-900">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="text-xl font-bold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-white text-xl transition-transform duration-300`}></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 pt-2">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Support */}
        <div className="mt-12 text-center p-8 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl border border-cyan-200">
          <p className="text-lg text-gray-700 mb-4">
            Still have questions? Our support team is here to help!
          </p>
          <a
            href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-cyan-600 font-bold hover:text-cyan-700 transition-colors cursor-pointer"
          >
            Contact Support
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
